<template>
<div id="catalogos_ubicaciones">
    <div>
        <v-breadcrumbs :items="breadcrumbs">
            <v-icon slot="divider">forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-row align-center justify-center>
            <v-col xs="12">
                <base-material-card color="primary" icon="mdi-google-maps" title="Administrar Ubicaciones" class="elevation-1 px-5 py-3">
                    <v-card-actions>
                        <v-spacer />
                        <v-speed-dial direction="left" open-on-hover>
                            <template v-slot:activator>
                                <v-btn x-small fab dark color="primary">
                                    <v-icon>reorder</v-icon>
                                </v-btn>
                            </template>
                            <exportar-excel :data="datafiltered" :exportFields="registros.camposexcel" name="Ubicaciones.xlsx" >
                                <v-btn fab x-small dark color="success" title="Exportar" v-tippy>
                                    <v-icon dark>get_app</v-icon>
                                </v-btn>
                            </exportar-excel>

                            <exportar-excel :data="registros.camposLayout" :exportFields="registros.encabezadoLayout" name="Layout Ubicaciones.xlsx" >
                                <v-btn fab dark x-small color="purple darken-2" title="Descargar Layout" v-tippy>
                                    <v-icon dark>receipt</v-icon>
                                </v-btn>
                            </exportar-excel>

                            <upload-excel-component v-if="permiso_edicion" :on-success="handleSuccess" :before-upload="beforeUpload" />
                                                
                        </v-speed-dial>
                            &nbsp;
                        <v-btn v-if="permiso_edicion" fab dark x-small color="primary" slot="activator" @click.native="agregar" title="Agregar Registro" v-tippy>
                            <v-icon dark>add</v-icon>
                        </v-btn>
                    </v-card-actions>
                    <v-card-text>
                        <div id="datagrid">
                            <v-client-table ref="vuetable" :data="items" :columns="columns" :options="options" class="elevation-2 pa-2">
                                <template slot="noResults">
                                    <v-alert :value="true" icon="info" color="info">No se encontró ningún registro</v-alert>
                                </template>
                                <template slot="actions" slot-scope="props">
                                    <v-btn x-small fab dark color="success" @click.native="editar(props.row.uuid)" title="Editar Registro" v-tippy>
                                           <v-icon  v-if="permiso_edicion"  small>mdi-pencil</v-icon>
                                         <v-icon  v-if="!permiso_edicion"  small>search</v-icon>
                                    </v-btn>&nbsp;
                                    <v-btn v-if="permiso_edicion" x-small fab dark color="pink" @click.native="eliminar(props.row.uuid)" title="Eliminar Registro" v-tippy>
                                        <v-icon>delete</v-icon>
                                    </v-btn>
                                </template>
                            </v-client-table>
                        </div>
                    </v-card-text>
                </base-material-card>
            </v-col>
        </v-row>
    </v-container>
    <v-dialog v-model="modal" max-width="60%">
        <v-card >
            <v-card-title>
                <span class="headline">{{ tituloModal }}</span>
            </v-card-title>

            <v-card-text>
                <v-container>
                    <v-form ref="form">
                        <v-card elevation="3" class="pa-5">
                            <v-card-text>
                                <v-row>
                                    <v-col sm="4" md="4" lg="4">
                                        <v-text-field v-model="model.identificador" label="ID Ubicación (6 digitos)" :rules="[rules.required, validaEntero]" minlength="6" maxlength="6"></v-text-field>
                                    </v-col>
                                    <v-col sm="4" md="4" lg="4">
                                        <v-text-field v-model="model.descripcion" label="Nombre del Remitente-Destinatario" :rules="[rules.required]"></v-text-field>
                                    </v-col>
                                    <v-col sm="4" md="4" lg="4">
                                        <v-text-field v-model="model.rfc" label="RFC o Número de Regtistro Tributario" :rules="[rules.required]" maxlength="30"></v-text-field>
                                    </v-col>
                                </v-row>
                                 <v-row>
                                    <v-col sm="4" md="4" lg="4">
                                        <v-text-field v-model="model.contacto" label="Nombre del contaco en Remitente-Destinatario" maxlength="150"></v-text-field>
                                    </v-col>
                                    <v-col sm="4" md="4" lg="4">
                                        <v-text-field v-model="model.email" label="E-mail"  maxlength="150"></v-text-field>
                                    </v-col>
                                    <v-col sm="4" md="4" lg="4">
                                        <v-text-field v-model="model.telefono" label="Teléfono"  maxlength="50"></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col sm="4" md="4" lg="4">
                                        <v-text-field v-model="model.domicilio.codigo_postal" label="Codigo Postal" @blur="searchCP" :rules="[validaEntero]" maxlength="5"></v-text-field>
                                    </v-col>
                                    <v-col sm="4" md="4" lg="4">
                                        <v-autocomplete v-model="model.domicilio.pais" label="País" :rules="[rules.required]" :loading="loadPais" @change="cargarEstados(model.domicilio.pais)" :items="sat_paises" :hide-no-data="true" item-text="nombre" item-value="clave"></v-autocomplete>
                                    </v-col>
                                    <v-col sm="4" md="4" lg="4">
                                        <v-autocomplete v-model="model.domicilio.estado" label="Estado" :loading="loadEstado" @change="cargarMunicipios(model.domicilio.estado); cargarLocalidades(model.domicilio.estado)" :items="sat_estados" :hide-no-data="true" item-text="nombre" item-value="clave"></v-autocomplete>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col sm="4" md="4" lg="4">
                                        <v-autocomplete v-model="model.domicilio.municipio" label="Municipio"  @change="searchColoniasCombo()" :loading="loadMunicipio" :items="sat_municipios" :hide-no-data="true" item-text="nombre" item-value="clave"></v-autocomplete>
                                    </v-col>
                                    <v-col sm="4" md="4" lg="4">
                                        <v-autocomplete v-model="model.domicilio.localidad" label="Localidad" @change="searchColoniasCombo()" :items="sat_localidades" :hide-no-data="true" item-text="nombre" item-value="clave"></v-autocomplete>
                                    </v-col>
                                    <v-col sm="4" md="4" lg="4">
                                        <v-autocomplete v-model="model.domicilio.colonia" label="Colonia" :loading="loadColonia" :items="sat_colonias" :hide-no-data="true" item-text="nombre" ></v-autocomplete>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col sm="6" md="6" lg="6">
                                        <v-text-field v-model="model.domicilio.calle" label="Calle" ></v-text-field>
                                    </v-col>
                                    <v-col sm="3" md="3" lg="3">
                                        <v-text-field v-model="model.domicilio.numero_ext" label="No. Exterior" :rules="[rules.required]"></v-text-field>
                                    </v-col>
                                    <v-col sm="3" md="3" lg="3">
                                        <v-text-field v-model="model.domicilio.numero_int" label="No. Interior"></v-text-field>
                                    </v-col>
                                </v-row>
                                 <v-row>
                                    <v-col sm="12" md="12" lg="12">
                                        <v-text-field v-model="model.domicilio.referencia" label="Referencia" ></v-text-field>
                                    </v-col>
                                   
                                </v-row>
                            </v-card-text>
                        </v-card>

                    </v-form>
                </v-container>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="default" small @click="modal=false">
                    <v-icon small>mdi-cancel</v-icon> Cancelar
                </v-btn>
                <v-btn color="success" small @click="guardar">
                    <v-icon small>mdi-check-circle-outline</v-icon> Guardar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</div>
</template>

<script>
import axios from "axios";
export default {
    name: "DashboardDataTables",
    created: function () {
        this.URL = this.$hostname + "carta_porte/catalogos/";
        this.URL_SAT = this.$hostname + "carta_porte/catalogos_sat/";
        this.model = this.clean_model();
        if (this.$local_storage.get("es_transportista") == 1 || this.$local_storage.get("es_agente") == 1) {
            this.id_empresa = this.$local_storage.get("rfc_grupo");                         
        } else {
            this.id_empresa = this.$local_storage.get("rfc");                
        }
        this.cargarPaises();
        this.cargar();
    },
    computed: {
        tituloModal() {
            return this.updateModel === false ? "Nueva Ubicación" : "Editar Ubicación";
        },
        datafiltered() {
        if (this.$refs.vuetable != null) {
            return this.$refs.vuetable.allFilteredData;
        } else {
            return this.items;
        }

    },
     permiso_edicion(){
            return (
               this.valida_permiso("Emanifiesto.catalogos.ubicaciones.crear") 
            );
    }
    },
    data: () => ({
        id_empresa:"",
        camposObligatorios: {
            "identificador":"IDUbicacion",
            "descripcion":"Nombre del Remitente Destinatario",
            "rfc":"RFC o Número de Regtistro Tributario",
            "pais": "Clave SAT País",   
        },
        registros:{
            camposexcel:{
            "IDUbicacion":"identificador",
            "Nombre del Remitente Destinatario":"descripcion",
            "RFC o Número de Regtistro Tributario":"rfc",
            "Nombre del contaco en Remitente-Destinatario":"contacto",
            "E-mail":"email",
            "Teléfono":"telefono",
            "CP":"domicilio.codigo_postal",      
            "Clave País": "domicilio.pais",
            "Clave Estado": "domicilio.estado",
            "Clave Municipio": "domicilio.municipio",
            "Clave Localidad":"domicilio.localidad",
            "Clave Colonia":"domicilio.colonia",
            "Calle": "domicilio.calle",
            "Número exterior": "domicilio.numero_ext",    
            "Número interior":"domicilio.numero_int",  
            "Reeferencia":"domicilio.referencia",  
            },
            encabezadoLayout:{
            "identificador":"identificador",
            "NombreRemitenteDestinatario":"NombreRemitenteDestinatario",
            "rfc":"rfc",
            "contacto":"contacto",
            "email":"email",
            "telefono":"telefono",
            "codigo_postal":"codigo_postal",      
            "pais": "pais",
            "estado": "estado",
            "municipio": "municipio",
            "localidad":"localidad",
            "colonia":"colonia",
            "calle": "calle",
            "numero_ext": "numero_ext",    
            "numero_int":"numero_int",
            "referencia":"referencia"      
            },
            camposLayout:[
            {
        
                "identificador":"[IDUbicacion (6 digitos)]",
                "NombreRemitenteDestinatario":"[Nombre del Remitente-Destinatario]",
                "rfc": "[RFC o Número de Regtistro Tributario]",
                "contacto":"[Nombre de la persona de contacto en la ubicación]",
                "email":"[Cuenta  de correo electrónico]",
                "telefono":"[Teléfono]",
                "codigo_postal":"[Código Postal]",      
                "pais": "[Clave SAT País]",
                "estado": "[Clave SAT Estado]",
                "municipio": "[Clave SAT Municipio]",
                "localidad":"[Clave SAT Localidad]",
                "colonia":"[Clave SAT Colonia]",
                "calle": "[Calle]",
                "numero_ext": "[Número Exterior]",    
                "numero_int":"[Número Interior]",
                "referencia":"[Referencia]"     
            }
            ],
        },
        URL:"",
        URL_SAT:"",
        sat_paises: [],
        sat_estados: [],
        sat_localidades: [],
        sat_municipios: [],
        sat_colonias: [],
        loadPais: false,
        loadLocalidad: false,
        loadEstado: false,
        loadMunicipio: false,
        loadColonia: false,

        tabla: "ubicaciones",
        modal: false,
        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/indext",
            },
            {
                text: "Ubicaciones",
                disabled: true,
                href: "",
            },
        ],
        model: {},
        updateModel: false,
        columns: ["identificador", "rfc", "descripcion", 'domicilio.calle', "actions"],
        options: {
            filterable: true,
            headings: {
                identificador: "IDUbicacion",
                rfc: "RFC o Número de Regtistro Tributario",
                descripcion: "Nombre del Remitente-Destinatario",
                'domicilio.calle': "Domicilio",
                actions: "Operaciones"
            }
        },
        items: [],
        search: undefined,
        rules: {
            required: v => !!v || "Este campo es requerido",
            numeric: value => {
                const pattern = /^[\d]*$/;
                return pattern.test(value) || "Solo se permiten números";
            }
        }

    }),
    methods: {
         valida_permiso(permiso) {
          return (
              this.$local_storage.get(permiso) == 100 
          );
        },
        searchCP: async function () {
            var val = this.model.domicilio.codigo_postal;
            if (val != null && val.toString().trim() != "" && val.toString().trim().length >= 4) {
                var cp = val.toString().trim();
                if (cp.length == 4) {
                    cp = "0" + cp;
                } else if (cp.length > 5) {
                    return false;
                }

                //console.log("CP: ",cp);        

                //TODO: Buscar codigo postal, traer estado, municipio, localidad para llenar esos combos
                var params = {
                    filtros:{
                        clave: cp,
                    },                    
                };

                var self = this;
                axios.post(this.URL_SAT + "list_codigos_postales/", params)
                    .then(res => {
                        if (typeof res.data !== "undefined") {
                            var codigo = res.data[0];

                            //Buscar estado                
                            self.sat_estados = [];
                            self.searchEstado(codigo);

                            //Buscar municipio                
                            self.sat_municipios = [];
                            self.searchMunicipio(codigo);

                            //Buscar localidad                
                            self.sat_localidades = [];
                            self.searchLocalidad(codigo);                       
                        }
                    })
                    .catch(err => {
                        this.$swal({
                            type: "error",
                            title: "Error",
                            text: "Ocurrió un error al buscar Código Postal.",
                            footer: "",
                        });
                        console.log(err);
                    });

                //Buscar Colonias        
                self.sat_colonias = [];
                this.searchColonias(cp);
            }
        },
        searchColonias: function (cp) {
            var self = this;
            self.loadColonia = true;
            
            var params = {
                filtros:{
                    codigo_postal: cp,
                }                
            };
            
            axios.post(this.URL_SAT + "list_colonias/", params)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        self.sat_colonias = res.data.sort(function (a, b) {
                            if (a.nombre > b.nombre)
                                return 1;
                            if (a.nombre < b.nombre)
                                return -1;
                            return 0;
                        });                  
                    }
                })
                .catch(err => {                        
                    this.$swal({
                        type: "error",
                        title: "Error",
                        text: "Ocurrió un error al buscar las colonias.",
                        footer: "",
                    });
                    console.log(err);
                }).then(()=>{
                    self.loadColonia = false;
                });

        },
        searchColoniasCombo: function () {
            var self = this;
            
            if ((self.model.domicilio.codigo_postal == null || self.model.domicilio.codigo_postal == "") &&
                self.model.domicilio.estado != null && self.model.domicilio.municipio != null &&
                self.model.domicilio.localidad != null) {

                this.sat_colonias=[]; 

                self.loadColonia = true;
                
                let params = {
                    filtros: {
                        clave_estado: self.model.domicilio.estado,
                        clave_municipio:self.model.domicilio.municipio,
                        clave_localidad:self.model.domicilio.localidad
                    }
                }
                axios.post(this.URL_SAT + "list_codigos_postales/", params)
                    .then(res => {
                        if (typeof res.data !== "undefined") {
                            var codigos = res.data;                            
                            codigos.forEach(element => {
                                self.searchColonias(element["clave"]);
                            });
                        } else
                            self.loadColonia = false;
                    })
                    .catch(err => {
                        this.$swal({
                            type: "error",
                            title: "Error",
                            text: "Ocurrió un error al buscar codigo postal para colonias.",
                            footer: "",
                        });
                        console.log(err);
                    });               
            }
        },
        getColonia: function (clave, cp) {
            var self = this;
            self.loadColonia = true;
            var params = {
                filtros: {
                    clave: clave,
                    codigo_postal: cp,
                },
            };

            axios.post(this.URL_SAT + "list_colonias/", params)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        self.sat_colonias = res.data;
                    }
                })
                .catch(err => {                        
                    this.$swal({
                        type: "error",
                        title: "Error",
                        text: "Ocurrió un error al obtener la colonia.",
                        footer: "",
                    });
                    console.log(err);
                }).then(()=>{
                    self.loadColonia = false;
                });
        },

        searchEstado: function (codigo) {
            var self = this;
            self.loadEstado = true;
            
            var params = {
                filtros:{
                    clave: codigo["clave_estado"]
                }                
            };

            axios.post(this.URL_SAT + "list_estados/", params)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        self.model.domicilio.pais = res.data[0]["clave_pais"];
                        self.cargarEstados(self.model.domicilio.pais);
                        self.model.domicilio.estado = res.data[0]["clave"];
                        self.cargarMunicipios(self.model.domicilio.estado);
                        self.cargarLocalidades(self.model.domicilio.estado);
                    }
                })
                .catch(err => {                        
                    this.$swal({
                        type: "error",
                        title: "Error",
                        text: "Ocurrió un error al buscar el estado.",
                        footer: "",
                    });
                    console.log(err);
                }).then(()=>{
                    self.loadEstado = false;
                });            

        },
        searchMunicipio: function (codigo) {
            var self = this;
            self.loadMunicipio = true;            
            var params = {
                filtros:{
                    clave:codigo["clave_municipio"],
                    clave_estado:codigo["clave_estado"]
                }                
            };
            
            axios.post(this.URL_SAT + "list_municipios/", params)
                .then(res => {
                    if (typeof res.data !== "undefined" && res.data.length>0) {
                        self.model.domicilio.municipio = res.data[0]["clave"];
                    }
                })
                .catch(err => {                        
                    this.$swal({
                        type: "error",
                        title: "Error",
                        text: "Ocurrió un error al buscar el municipio.",
                        footer: "",
                    });
                    console.log(err);
                }).then(()=>{
                    self.loadMunicipio = false;
                });    
         
        },
        searchLocalidad: function (codigo) {
            var self = this;
            if (codigo["clave_localidad"] != null && codigo["clave_localidad"] != "") {
                self.loadLocalidad = true;                
                var params = {
                    filtros:{
                        clave: codigo["clave_localidad"],
                        clave_estado: codigo["clave_estado"]
                    }                    
                };
                axios.post(this.URL_SAT + "list_localidades/", params)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        self.model.domicilio.localidad = res.data[0]["clave"];
                    }
                })
                .catch(err => {                        
                    this.$swal({
                        type: "error",
                        title: "Error",
                        text: "Ocurrió un error al buscar la localidad.",
                        footer: "",
                    });
                    console.log(err);
                }).then(()=>{
                    self.loadLocalidad = false;
                });                 
            }
        },
        cargarPaises: function () {
            var self = this;
            self.loadPais = true;
            self.sat_paises = [];
            axios.post(this.URL_SAT + "list_paises/")
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        self.sat_paises = res.data.sort(function (a, b) {
                            if (a.nombre > b.nombre)
                                return 1;
                            if (a.nombre < b.nombre)
                                return -1;
                            return 0;
                        });
                    }
                })
                .catch(err => {                        
                    this.$swal({
                        type: "error",
                        title: "Error",
                        text: "Ocurrió un error al obtener los países.",
                        footer: "",
                    });
                    console.log(err);
                }).then(()=>{
                    self.loadPais = false;
                });              
        },
        cargarEstados: function (clave_pais) {
            //console.log("CARGAR ESTADOS");
            var params = {
                filtros:{
                    clave_pais: clave_pais
                }                
            };
            var self = this;
            self.loadEstado = true;
            self.sat_estados = [];
            axios.post(this.URL_SAT + "list_estados/", params)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        self.sat_estados = res.data.sort(function (a, b) {
                            if (a.nombre > b.nombre)
                                return 1;
                            if (a.nombre < b.nombre)
                                return -1;
                            return 0;
                        });
                    }
                })
                .catch(err => {                        
                    this.$swal({
                        type: "error",
                        title: "Error",
                        text: "Ocurrió un error al obtener los estados.",
                        footer: "",
                    });
                    console.log(err);
                }).then(()=>{
                    self.loadEstado = false;
                }); 
            
        },
        cargarMunicipios: function (clave_estado) {
            var params = {
                filtros:{
                    clave_estado: clave_estado
                }                
            };
            var self = this;
            self.loadMunicipio = true;
            self.sat_municipios = [];
            axios.post(this.URL_SAT + "list_municipios/", params)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        self.sat_municipios = res.data.sort(function (a, b) {
                            if (a.nombre > b.nombre)
                                return 1;
                            if (a.nombre < b.nombre)
                                return -1;
                            return 0;
                        });
                    }
                })
                .catch(err => {                        
                    this.$swal({
                        type: "error",
                        title: "Error",
                        text: "Ocurrió un error al obtener los municipios.",
                        footer: "",
                    });
                    console.log(err);
                }).then(()=>{
                    self.loadMunicipio = false;
                }); 
            
        },
        cargarLocalidades: function (clave_estado) {
            var params = {
                filtros:{
                    clave_estado: clave_estado
                }                
            };
            var self = this;
            self.loadLocalidad = true;
            self.sat_localidades = [];
            axios.post(this.URL_SAT + "list_localidades/", params)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        self.sat_localidades = res.data.sort(function (a, b) {
                            if (a.nombre > b.nombre)
                                return 1;
                            if (a.nombre < b.nombre)
                                return -1;
                            return 0;
                        });
                    }
                })
                .catch(err => {                        
                    this.$swal({
                        type: "error",
                        title: "Error",
                        text: "Ocurrió un error al obtener las localidades.",
                        footer: "",
                    });
                    console.log(err);
                }).then(()=>{
                    self.loadLocalidad = false;
                }); 
            
        },

        validaEntero: function (value) {
            const pattern = /^[\d]*$/;
            if (value != null && !pattern.test(value)) {
                return "Solo se acepta números";
            }
            return true;
        },
        cargar: function () {
            this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
            
            let data = {
                uuid_empresa: this.model.uuid_empresa,
            };

            var self = this;
            axios.post(this.URL + "list_ubicaciones/", data)
                    .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.items = res.data;
                        /*this.datos.sort(function(a, b) {
                            //Ordenar por fecha más reciente
                            return new Date(b.fecha_solicitud) - new Date(a.fecha_solicitud);
                        });
                        for (var k in this.datos) {
                            this.datos[k].fecha_solicitud = this.parseDate(this.datos[k].fecha_solicitud);
                            this.datos[k].fecha_generacion = this.parseDate(this.datos[k].fecha_generacion);
                            this.datos[k].estatus = this.getEstatus(this.datos[k].estatus);
                            this.datos[k].criterio = this.getCriterioPredeterminadosDS(this.datos[k].criterio);
                        }*/
                    }
                    })
                    .catch(err => {
                        this.$swal({
                            type: "error",
                            title: "Error",
                            text: "Ocurrió un error al obtener los registros.",
                            footer: "",
                        });
                        console.log(err);
                    }).then(() => {
                        this.$root.$dialogLoader.hide();
                    });                      
        },

        agregar: function () {
            this.model = this.clean_model();
            this.updateModel = false;
            this.modal = true;

        },
        editar: function (id) {
            this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
            var self = this;
            this.model = this.clean_model();
            var data = {                
                uuid: id,
                uuid_empresa: this.model.uuid_empresa,
            };
            axios.post(this.URL + "list_ubicaciones/", data)
                .then(res => {
                if (typeof res.data !== "undefined") {
                    self.model = res.data[0];
                    //self.indexSeleccionado = self.model.uuid;
                    
                    if(self.model.domicilio.codigo_postal!=null && self.model.domicilio.codigo_postal!="")
                        self.searchColonias(self.model.domicilio.codigo_postal);
                    else 
                        self.searchColoniasCombo();
                    if(self.model.domicilio.pais!=null && self.model.domicilio.pais!="")        
                        self.cargarEstados(self.model.domicilio.pais);
                    if(self.model.domicilio.estado!=null && self.model.domicilio.estado!=""){
                        self.cargarMunicipios(self.model.domicilio.estado);
                        self.cargarLocalidades(self.model.domicilio.estado);
                    }
                    
                    this.modal = true;
                    this.updateModel = true;
                }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "Error",
                        text: "Ocurrió un error al obtener el registro.",
                        footer: "",
                    });
                    console.log(err);
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });

        },
        eliminar: function (id) {
            var self = this;
            self.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de eliminar el registro?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(result => {
                if (result.value) {
                    this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
                    var data = {
                        uuid: id,                        
                    };
                    axios.post(this.URL + "delete_ubicacion/", data)
                        .then(res => {
                            self.$swal({
                                type: "success",
                                title: "¡Operación Exitosa!",
                                text: "El registro se eliminó correctamente.",
                                footer: "",
                            });
                            self.cargar();
                        })
                        .catch(err => {
                            this.$swal({
                                type: "error",
                                title: "Error",
                                text: "Ocurrió un error al eliminar el registro.",
                                footer: "",
                            });
                            console.log(err);
                        }).then(() => {
                            this.$root.$dialogLoader.hide();
                        });
                    
                }
            });

        },
        guardar: function () {
            if (!this.$refs.form.validate()) {
                //Alguna operación o mensaje
            } else {
                this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
                var url = this.URL + "create_ubicacion/";
                                
                if (this.updateModel === false) 
                    this.model.uuid = this.$uuid.v4();
                else 
                    url = this.URL + "update_ubicacion/";
                    
                var self = this;
                console.log(this.model);
                //return true;

                axios.post(url, this.model)
                    .then(res => {                    
                        self.$swal({
                            type: "success",
                            title: "¡Operación Exitosa!",
                            text: "El registro se guardó correctamente.",
                            footer: "",
                        });
                        self.modal = false;                                          
                    })
                    .catch(err => {
                        console.log(err);
                        self.$swal({
                            type: "error",
                            title: "Error",
                            text: "Ocurrió un error al guardar el registro.",
                            footer: "",
                        });                        
                    }).then(() => {
                        this.add_registro = false;
                        self.cargar();
                        this.$root.$dialogLoader.hide();
                    });                  
                            
            }
        },
        clean_model: function () {
            this.sat_estados = [];
            this.sat_municipios = [];
            this.sat_localidades = [];
            this.sat_colonias = [];
            var rfc = "";
            if (this.$local_storage.get("es_transportista") == 1 || this.$local_storage.get("es_agente") == 1) {
                rfc = this.$local_storage.get("rfc_grupo");                         
            } else {
                rfc = this.$local_storage.get("rfc");                
            }
            
            return {
                uuid: "",
                uuid_empresa: rfc,
                identificador: "",
                descripcion: "",
                domicilio: {
                    calle: "",
                    numero_int: "",
                    numero_ext: "",
                    colonia: "",
                    localidad: "",
                    municipio: "",
                    estado: "",
                    pais: "",
                    codigo_postal: ""
                },
            };
        }, 
        beforeUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (isLt2M) {
                return true;
            }
            this.$swal({
                type: "warning",
                title: "¡Operación no Permitida!",
                text: "El archivo no debe ser mayor a 2MB.",
                footer: ""
            });
            return false;
        },
        verificaObligatorios: function (results) {
            var errores = '';
            var keys = [];
            for (var k in results) {
                keys.push(k);
            }

            for (var key in this.camposObligatorios) {
                if (keys.indexOf(key) == -1)
                    errores += '<br/>' + "- El campo '" + key + "' es obligatorio.";
            }

            return errores == '' ? true : errores;
        },
        validaCargaLayout: async function (results) {
            var thisObject = this;
            //return new Promise(function(resolve, reject){
            var errores = 0;
            var renglonesLeidos = 0;
            var erroresText = "";
            var aduanasContactoRfc = [];
            var aduanasDomicilioRfc = [];
            try {
                if (results.length == 0) {
                    errores++;
                    erroresText += "No hay datos en el layout. Verifique que exista información a partir del 3er renglón.";
                } else if (results.length > 100){
                    errores++;
                    erroresText += "El máximo de filas a procesar es 500, favor de verificar.";
                } else {

                    for (var k in results) {
                        renglonesLeidos++;
                        results[k]["uuid"] = thisObject.$uuid.v4();
                        results[k]["uuid_empresa"] = thisObject.id_empresa;
                        results[k]["user_updated"] = thisObject.$local_storage.get("email");
                        
                        var obligatorios = thisObject.verificaObligatorios(results[k]);
                        if (obligatorios !== true) {
                            errores++;
                            if (erroresText.indexOf(obligatorios) == -1)
                                erroresText += obligatorios;
                        } else {

                            if(results[k]["identificador"].toString().trim().length>6 ){
                                errores++;
                                erroresText += "El identificador "+results[k]["identificador"]+" no debe tener más de 6 digitos<br>";
                            }
                            if(thisObject.validaEntero(results[k]["identificador"])!==true){
                                errores++;
                                erroresText += "El identificador "+results[k]["identificador"]+" solo debe contener numeros<br>";
                            }

                            if(results[k]["rfc"].toString().trim().length>50 ){
                                errores++;
                                erroresText += "El rfc "+results[k]["rfc"]+" no debe tener más de 50 caracteres<br>";
                            }

                        }
                        //console.log("Key is " + k + ", value is" + results[k]);
                    }
                }

                return {
                    errores: errores,
                    erroresText: erroresText
                };
            } catch (error) {
                console.log(error);
                thisObject.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al cargar el archivo. Verifique que no existan celdas vacías.",
                    footer: error.message
                });
            }
            //}); //promise
        },
        handleSuccess: async function ({
            results,
            header
        }) {
            var errores = 0;
            var erroresText = "";
            
            this.importData = [];
            try {
                this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
                let validaciones = await this.validaCargaLayout(results);
                if (validaciones.errores > 0) {
                    this.$swal({
                        type: "warning",
                        title: "¡Operación no Permitida!",
                        text: "Existen errores al cargar el archivo. Corrija y vuelva a intentarlo.",
                        footer: validaciones.erroresText
                    });
                    this.$root.$dialogLoader.hide();
                } else {
                    for (var k in results) {
                        
                        this.importData.push({
                            uuid: results[k]["uuid"],
                            uuid_empresa: results[k]["uuid_empresa"],
                            identificador: results[k]["identificador"],
                            descripcion: results[k]["NombreRemitenteDestinatario"],
                            rfc: results[k]["rfc"],
                            contacto: results[k]["contacto"],
                            email: results[k]["email"],
                            telefono: results[k]["telefono"],
                            domicilio: {
                                calle: results[k]["calle"],
                                numero_int: results[k]["numero_int"]!=undefined?results[k]["numero_int"]:"",
                                numero_ext: results[k]["numero_ext"],
                                colonia: results[k]["colonia"]!=undefined?results[k]["colonia"]:"",
                                localidad: results[k]["localidad"]!=undefined?results[k]["localidad"]:"",
                                municipio: results[k]["municipio"],
                                estado: results[k]["estado"],
                                pais: results[k]["pais"],
                                codigo_postal: results[k]["codigo_postal"]!=undefined?results[k]["codigo_postal"]:"",
                                referencia: results[k]["referencia"]!=undefined?results[k]["referencia"]:""
                            },
                        });

                    }

                    axios
                        .post(this.URL + "importar_ubicaciones/", this.importData)
                        .then(() => {
                            this.$swal({
                                type: "success",
                                title: "¡Operación Exitosa!",
                                text: "Los datos se guardaron correctamente",
                                footer: ""
                            });
                        })
                        .catch(err => {
                            var errores = "";
                            if (typeof err.response.data != "undefined") {
                                if (typeof err.response.data == "string") {
                                    let pos = errores.indexOf(err.response.data);
                                    if (pos < 0) {
                                        errores += err.response.data;
                                        errores += "<br>";
                                    }
                                } else
                                        for (var i = 0; i < err.response.data.length; i++) {
                                            Object.keys(err.response.data[i]).forEach(function (key) {
                                                var errors = err.response.data[i][key];                                            
                                                    Object.keys(errors).forEach(function (key2) {
                                                        let pos = errores.indexOf(key + ": " + errors[key2]);
                                                        if (pos < 0) {
                                                            errores += key + ": " + errors[key2];
                                                            errores += "<br>";
                                                        }
                                                    });
                                                
                                            });
                                        }
                            }
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Existen errores al cargar el archivo. Corrija y vuelva a intentarlo. \nVerifique que los encabezados correspondan con el layout.",
                                footer: errores
                            });
                        })
                        .then(() => {
                            this.cargar();
                            this.$root.$dialogLoader.hide();
                        });
                }
            } catch (error) {
                this.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al cargar el archivo. Verifique que no existan celdas vacías.",
                    footer: error.message
                });
                this.$root.$dialogLoader.hide();
            }
        },
    },
};
</script>
